import {
  Theme,
  TypographyVariant,
  WithTheme,
  assertTheme,
  interpolateRhythmMargin,
} from '@mint/core';
import { ListProps } from './list-props';
import PropTypes from 'prop-types';
import React from 'react';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'list';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'ul';

/**
 * List component implementation before styling.
 */
export const ListComponent = React.forwardRef<any, ListProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      dense,
      theme: _,
      ...rest
    } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return <Component {...componentProps}>{children}</Component>;
  },
);

ListComponent.displayName = 'List';

export const List = styled(ListComponent)`
  list-style: none;
  padding: 0;
`;
